import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { responsiveContainerStyles } from './styles'

const ResponsiveContainer = ({ children, ratio = 'ratio-16-9' }) => {
  return (
    <div className={classnames('responsive-container', ratio)}>
      <div className="responsive-container-body">
        <div className="responsive-container-content">{children}</div>
      </div>

      <style jsx>{responsiveContainerStyles}</style>
    </div>
  )
}

ResponsiveContainer.propTypes = {
  ratio: PropTypes.oneOf(['ratio-16-9', 'ratio-1-1', 'ratio-2-1', 'ratio-1-120']),
  // You can add a simple new selector in styles.js to extend this functionality
}

ResponsiveContainer.defaultProps = {
  ratio: 'ratio-16-9'
}

export default ResponsiveContainer
